/*
 * File: cell-ledger-name.ts
 * Created: 2026-02-03
 * Author: Val Liu
 */

import { Component } from "vue-property-decorator";
import { BaseTableBodyCell } from "@root/components/table/core/lib/base-table-body-cell/base-table-body-cell";

@Component
export default class CellLedgerName extends BaseTableBodyCell {
    get sourceLabel() {
        const key = {
            INITIAL_CREDIT: "w_LedgerSourceInitialCredit",
            USER_DEPOSIT: "w_LedgerSourceDeposit",
            PROMO_CREDIT: "w_LedgerSourcePromoCredit",
            USAGE_DEBIT: "w_LedgerSourceUsageDebit",
            REFUND: "w_LedgerSourceRefund",
        }[this.sourceType];
        return key ? this.$_(key) : "";
    }

    get nameText() {
        if (this.sourceLabel) return this.sourceLabel;
        const value = this.value ?? this.row?.name;
        if (value) return String(value);
        return "-";
    }

    get idText() {
        const raw = this.row?.id ? String(this.row.id) : "";
        if (!raw) return "-";
        return `#${raw.slice(0, 8)}`;
    }

    get sourceType() {
        return String(this.row?.source ?? "").toUpperCase();
    }

    get variantClass() {
        if (this.sourceType === "USER_DEPOSIT" || this.sourceType === "INITIAL_CREDIT")
            return "tx-deposit";
        if (this.sourceType === "PROMO_CREDIT") return "tx-deposit";
        if (this.sourceType === "REFUND") return "tx-deposit";
        return "tx-usage";
    }

    get iconClass() {
        if (this.sourceType === "USER_DEPOSIT" || this.sourceType === "INITIAL_CREDIT")
            return "fa-arrow-up";
        if (this.sourceType === "PROMO_CREDIT") return "fa-gift";
        if (this.sourceType === "REFUND") return "fa-rotate-left";
        return "fa-file-alt";
    }
}
